import _module from 'module.js'
import greetingRecorderWizardTemplate
  from './greetingRecorderWizardTemplate.html'
import jrnParser from 'classes/jrnParser'

class greetingRecorderController {
  constructor (gettextCatalog, $mdDialog) {
    'ngInject'
    this.soundClip = {
      name: 'New Recording',
      description: ''
    }

    this.jrn = jrnParser
    this.gettextCatalog = gettextCatalog
    this.$mdDialog = $mdDialog
  }

  ok () {
    let blob = this.audio.element.recordRTC.getBlob()
    let fileName = 'greeting.wav'

    let file = new Blob([blob], {
      type: 'audio/wav'
    })
    file.name = fileName

    this.$mdDialog.hide(file)
  }

  cancelDialog () {
    this.$mdDialog.cancel()
  }

  static factory (gettextCatalog, $mdDialog) {
    'ngInject'
    return new greetingRecorderController(gettextCatalog, $mdDialog)
  }
}

class GreetingRecorderWizard {
  constructor ($mdDialog) {
    'ngInject'
    this.$mdDialog = $mdDialog
  }

  open () {
    return this.$mdDialog.show({
      template: greetingRecorderWizardTemplate,
      controllerAs: 'comboWizard',
      controller: greetingRecorderController.factory,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true
    })
  }

  static factory ($mdDialog) {
    'ngInject'
    return new GreetingRecorderWizard($mdDialog)
  }
}

_module.factory('greetingRecorderWizard', GreetingRecorderWizard.factory)
